import { type ReactElement, type ReactNode } from "react"
import Navbar from "src/components/Navbar"
import OrderManagementMain from "./Main/OrderManagementMain"
import { useLocation } from "react-router-dom"
import Sidebar from "src/components/Sidebar"

export interface OrderManagementHomeProps {
        dealerId?: string;
        browhistory: string;
        children?: ReactNode;
}

export default function OrderManagementHome(props: OrderManagementHomeProps): ReactElement {
        const location = useLocation();
        return <>
                <div className="grid grid-cols-[10%_90%] h-full w-full">
                        <div className="h-full">
                                <Sidebar sideBarSelected="OrderManagement" />
                        </div>
                        <div className="grid grid-rows-[10%_90%] h-full gap-2 w-full p-2">
                                <div className="w-full">
                                        <Navbar headerType="order" />
                                </div>
                                <div className="grid grid-rows-1 grid-cols-1 w-full h-full">
                                        <OrderManagementMain dealerId={props.dealerId} />
                                </div>
                        </div>
                </div>
        </>
}
